import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { AGREEMENT_PATH } from 'volto-m4-theme-addon/constants';
import {
  memberUrl,
  memberGetFolder,
} from 'volto-m4-theme-addon/actions/member/member';

const pathsToIgnore = [AGREEMENT_PATH, /[.]*\/logout\/?$/, /[.]*\/login\/?$/];

function shouldIgnore(path) {
  for (var pathToIgnore of pathsToIgnore) {
    if (typeof pathToIgnore === 'string') {
      if (path === pathToIgnore) {
        return true;
      }
    } else {
      if (pathToIgnore.test(path)) {
        return true;
      }
    }
  }
  return false;
}

const AgreementRedirect = () => {
  const history = useHistory();
  const location = useLocation();
  const token = useSelector((state) => state.userSession.token);
  const member = useSelector((state) => state.memberFolder.member.member);
  const memberFolderUrl = useSelector(
    (state) => state.memberUrl.member.member_url,
  );

  const dispatch = useDispatch();

  const isAuthenticated = !!token;

  useEffect(() => {
    dispatch(memberUrl());
  }, [token, dispatch]);

  useEffect(() => {
    if (memberFolderUrl) {
      dispatch(memberGetFolder(memberFolderUrl));
    }
  }, [memberFolderUrl, dispatch]);

  useEffect(() => {
    if (member) {
      if (isAuthenticated && !member.user_agrees_to_terms) {
        if (!shouldIgnore(location.pathname)) {
          const path = `${AGREEMENT_PATH}?came_from=${encodeURIComponent(location.pathname)}`;
          history.push(path);
        }
      }
    }
  });

  return <></>;
};

export default AgreementRedirect;
